import { createSignal, createMemo } from "solid-js";

export type EntitySelection = ReturnType<typeof useEntitySelection>;
export const useEntitySelection = () => {
  const [selected, setSelected] = createSignal<Record<string, boolean>>({});

  const allSelected = (entities: { id: string }[]) => entities.every((a) => selected()[a.id]);
  const someSelected = (entities: { id: string }[]) => entities.some((a) => selected()[a.id]);
  // Toggle all visible checkboxes
  function toggleAll(checked: boolean, entities: { id: string }[]) {
    const ids = entities.map((a) => a.id);
    setSelected((prev) => {
      const next = { ...prev };
      ids.forEach((id) => {
        next[id] = checked;
      });
      return next;
    });
  }

  const selectedIds = createMemo(() =>
    Object.entries(selected())
      .filter(([_, value]) => value)
      .map(([id]) => id),
  );

  return {
    allSelected,
    someSelected,
    toggleAll,
    selected,
    setSelected,
    selectedIds,
  };
};
